import clsx from 'clsx';

import styles from './FilledLeftArrow.module.css';
import { FilledLeftArrowProps } from './types';

const FilledLeftArrow = ({ isOpened, className, width = '12', height = '12' }: FilledLeftArrowProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 35 40"
      fill="none"
      className={clsx(styles.filledSVG, { [styles.filledSVGRotate]: isOpened }, className)}
    >
      <path d="M-9.61651e-07 20L34.5 0.94744L34.5 39.0526L-9.61651e-07 20Z" fill="black" />
    </svg>
  );
};

export default FilledLeftArrow;
